import React from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  BlogCard,
  Layout,
} from 'components';
import './packages-and-payment-page.less';

import './blog.less';
import marketingImg from 'assests/images/blog-toplu-mms.jpg';
import blogBannerAccessory1 from 'assests/images/pap-accessory-1.png';
import blogBannerAccessory2 from 'assests/images/features-accessory-3.png';
import { LANDING_MENU } from 'constants/page.const';
import { MetaTags } from 'react-meta-tags';

const YeniYil = () => {
  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      <MetaTags>
        <title>
        Yeni Yıl Mesajları - Mesaj Üssü
        </title>
        <meta
          name="description"
          content="Sizler için 2023 yılına özel en etkileyici ve kurumsal yılbaşı mesajlarını derledik. Yeni yıl mesajlarını kullanarak sevdiklerinize toplu SMS atın."
        />
        <link
          rel="canonical"
          href="https://mesajussu.turkcell.com.tr/yeni-yil-mesajlari"
        />
      </MetaTags>
      <div className="blog-page blog-page--marketing">
        <div className="blog-banner">
          <div className="container">
            <div>
              <h1 className="section__title--big">
              Yeni Yıl Mesajları
              </h1>
              <p className="info-text--big">
                Sizler için 2023 yılına özel en etkileyici ve kurumsal yılbaşı
                mesajlarını derledik. Yeni yıl mesajlarını kullanarak
                sevdiklerinize toplu SMS atın.
              </p>
            </div>
            <figure>
              <img src={marketingImg} alt="Yeni Yıl Mesajları - Mesaj Üssü" />
            </figure>
          </div>
          <img
            id="blog-banner-accessory-1"
            src={blogBannerAccessory1}
            alt="Yeni Yıl Mesajları - Mesaj Üssü 2"
          />
          <img
            id="blog-banner-accessory-2"
            src={blogBannerAccessory2}
            alt="Yeni Yıl Mesajları - Mesaj Üssü 3"
          />
        </div>
        <div className="blogs-wrapper">
          <div className="container">
            <ul>
              <li>
                <h1>Yeni Yıl Mesajları</h1>
              </li>
              <h2>
                <strong>Yeni Yıl Mesajlarının &ouml;nemi Nedir</strong>?
              </h2>
              <p>
                Yeni yıl, hayaller ve umutlarla dolu taze bir başlangı&ccedil;.
                İyisiyle k&ouml;t&uuml;s&uuml;yle gelip ge&ccedil;en bir yılı
                geride bırakırken yeni bir başlangı&ccedil; yapmanın heyecanı
                paha bi&ccedil;ilemez. Bu &ouml;zel g&uuml;nde yaşanılanlar son
                kez g&ouml;zden ge&ccedil;irilir ve farkındalıklar artırılarak
                yeni kararlar alınır. Gelecek i&ccedil;in yeni planların
                yapıldığı bu g&uuml;nde sevgi, huzur ve barış dilekleri de
                b&uuml;y&uuml;k &ouml;nem kazanır.
                <strong>Yılbaşı mesajları</strong> ise sevdiklerimizle
                mutluluğumuzu paylaşmanın en keyifli yolu.
              </p>
              <p>
                Yılbaşı, sadece takvimde bir rakamın değişmesi değil aynı
                zamanda sevdiklerinle bir araya gelip mutluluğu doyasıya
                paylaşabileceğin bir g&uuml;n. Ancak onlardan uzaktaysan
                varlığını hissettirmek ve aklında olduklarını g&ouml;stermek
                i&ccedil;in <strong>yılbaşı tebriklerini</strong> mesajla
                iletebilirsin. Yeni yıl mesajları da en az klasik ama etkileyici
                bir y&ouml;ntem olan yılbaşı tebrik kartı kadar değerli.
                Mutluluk, neşe, coşku ve umut gibi değerli duyguları paylaşmak
                i&ccedil;in ise birebir.
              </p>
              <p>
                Mesaj &uuml;ss&uuml; ile farklı ihtiya&ccedil;lara y&ouml;nelik
                olarak sunulan{' '}
                <a
                  href="https://mesajussu.turkcell.com.tr/paketler"
                  target="_blank"
                >
                  <strong>
                    <u>SMS paketleri</u>
                  </strong>
                </a>
                , hemen hemen her isteği ve beklentiyi karşılayacak şekilde
                geliştirilir. Uzun ve kısa vadeli planlarını g&ouml;z
                &ouml;n&uuml;nde bulundurarak toplu SMS paketlerini tercih
                edebilirsin. B&ouml;ylece sevdiklerine{' '}
                <strong>etkileyici yeni yıl mesajları</strong> atman
                m&uuml;mk&uuml;n olur. Yeni yıla girerken aile &uuml;yelerine
                g&ouml;nderebileceğin bazı yılbaşı mesaj şablonları şu şekilde;{' '}
              </p>
              <ul>
                <li>
                  Bir yılı daha geride bırakırken varlığınıza minnettarım. Her
                  ge&ccedil;en yılda iyi ki benim ailemsiniz diyeceğim. Her yeni
                  yaşımda iyi ki d&uuml;nyaya gelme sebebim sizsiniz diyerek
                  teşekk&uuml;r edeceğim. İyi ki varsınız canım ailem, sizi
                  &ccedil;ok seviyorum.
                </li>

                <li>
                  En b&uuml;y&uuml;k dayanağım, en y&uuml;ce mutluluğum, canım
                  ailem. Her yıl olduğu gibi bu yeni yılda da yanımda olduğunuz
                  ve bana destek verdiğiniz i&ccedil;in teşekk&uuml;r ederim.
                  Sağlık, huzur ve mutlulukla hep beraber ge&ccedil;en nice
                  yıllarımız olsun.
                </li>
                <li>
                  Her gelen yeni yılda sa&ccedil;larımızdaki aklar artacak,
                  belki de g&ouml;zlerimize yorgunluk &ccedil;&ouml;kmeye
                  başlayacak. Her yılbaşında bir şeyler mutlaka değişmiş olacak.
                  Değişmeyen tek şey sevgi dolu ailemiz olacak. Hep yanımda
                  kalmanız dileğiyle, mutlu yıllar canım ailem.{' '}
                  <li>
                    Bu yılbaşında da benim i&ccedil;in en g&uuml;zel hediye
                    sevdiklerimin varlığı. Yeni yılda t&uuml;m dilekleriniz
                    ger&ccedil;ek olsun sevgili ailem.{' '}
                  </li>
                  <li>
                    Yeni yılda y&uuml;z&uuml;n&uuml;zden tebess&uuml;m,
                    kalbinizden mutluluk eksik olmasın. Sizi &ccedil;ok
                    seviyorum canım ailem, mutlu yıllar.{' '}
                  </li>
                  <li>
                    Yeni yıldan dileğim her yeni g&uuml;n&uuml;m&uuml;z&uuml;n
                    bir &ouml;ncekinden daha keyifli ge&ccedil;tiği mutlu ve
                    huzurlu bir yıl olması. Varlığınızdan daha g&uuml;zel bir
                    hediye yok benim i&ccedil;in. Mutlu yıllarımız olsun.{' '}
                  </li>
                  <li>
                    {' '}
                    Bu yıl ve her gelecek yıl i&ccedil;in tek hayalim,
                    kahkahalarımızın sonsuza dek yankılanması! Birlikte
                    ge&ccedil;en yıllarımız hi&ccedil; bitmesin ailem. Mutlu
                    yıllar!
                  </li>
                  <li>
                    Bana sevginin ve mutluluğun temellerini &ouml;ğreten canım
                    ailem, varlığınız bana g&uuml;&ccedil; katıyor.
                    Bug&uuml;n&uuml;mde, yarınımda ve her anımda benimle
                    olduğunuz i&ccedil;in teşekk&uuml;r ederim. Nice sağlıklı ve
                    huzurlu senelerimiz olsun.
                  </li>
                  <li>
                    Beraber her yeni yılımızda bir yaş daha atsam da
                    varlığınızla mutlu ve g&uuml;vende hissediyorum.
                    &ouml;m&uuml;r boyu beraber ge&ccedil;irmek dileğiyle iyi ki
                    varsınız canım ailem. Nice mutlu yıllara!
                  </li>
                  <li>
                    <p>
                      D&uuml;nyayı değiştirmek istersen kalbine g&uuml;ven,
                      sevgiye inan ve ailene sarıl. Yeni yıl size kocaman
                      sarılacağım g&uuml;nler getirsin. Mutlu seneler!
                    </p>
                  </li>
                </li>
              </ul>
              <p>
                Etkileyici yılbaşı s&ouml;zleriyle ailenin yeni yılını
                kutlayabilirsin.
                <a
                  href="https://mesajussu.turkcell.com.tr/paketler"
                  target="_blank"
                >
                  {' '}
                  <strong>
                    <u>Mesaj &uuml;ss&uuml; paketleri</u>
                  </strong>
                </a>
                ni değerlendirerek aile &uuml;yelerine
                <a
                  href="https://mesajussu.turkcell.com.tr/toplu-sms"
                  target="_blank"
                >
                  {' '}
                  <strong>
                    <u> toplu SMS</u>
                  </strong>
                </a>{' '}
                atman da m&uuml;mk&uuml;n. Bu sayede yeni yıl mutluluğunu
                ailenle son derece pratik bir şekilde paylaşabilirsin.
              </p>

              <h2>
                <strong>
                  Kurumsal Şirketler i&ccedil;in Yeni Yıl Mesajları
                </strong>
              </h2>

              <p>
                <strong>Kurumsal yeni yıl mesajları</strong> ile en az ailen
                kadar birlikte vakit ge&ccedil;irdiğin ve aynı ama&ccedil;
                uğruna bir ekip olarak &ccedil;alıştığın iş arkadaşlarına da en
                g&uuml;zel dileklerini iletebilirsin. Gelmekte olan yıla dair
                umutların bulunduğu nezaket dolu kurumsal yeni yıl tebrik
                kartları i&ccedil;in şu şablonları kullanabilirsin;
              </p>
              <ul>
                <li>
                  Yeni yıla girerken mutluluk, sağlık ve başarı diliyorum. Her
                  işten keyif alacağımız, ailemizi daha da
                  b&uuml;y&uuml;teceğimiz keyifli yıllarımız olsun.
                </li>
                <li>
                  Şirketimizdeki &uuml;st&uuml;n başarılarından dolayı yeni
                  yılda size daha fazla başarı dilemeye gerek duymuyoruz. Mutlu,
                  sağlıklı ve keyifli bir yıl ge&ccedil;irmenizi temenni ederim.
                </li>

                <li>
                  {' '}
                  Yeni yılda her şeyin g&ouml;nl&uuml;n&uuml;zce olmasını ve
                  t&uuml;m dileklerinizin kısa zamanda ger&ccedil;ekleşmesini
                  dilerim.
                </li>
                <li>Kariyerinin zirvesinde bir yıl dilerim!</li>
                <li>
                  Senin gibi bir &ccedil;alışana sahip olduğumuz i&ccedil;in
                  şirket&ccedil;e &ccedil;ok şanslıyız. İyi seneler!
                </li>
                <li>
                  X firması olarak yeni yılınızı en i&ccedil;ten dileklerimizle
                  kutlar sevdiklerinizle huzurlu bir yıl ge&ccedil;irmenizi
                  dileriz.
                </li>
                <li>
                  Şirketimizi bir adım daha &ouml;teye taşımak i&ccedil;in
                  verdiğiniz emeklerle her saniye daha da başarılı olacağımız
                  bir yıl diliyor, sevdiklerinizin yanınızdan hi&ccedil; eksik
                  olmamasını temenni ediyoruz. İyi seneler.
                </li>
                <li>
                  &uuml;lkemiz ve firmamız i&ccedil;in g&uuml;zel bir yıl
                  olmasını diliyor, sevdiklerinizle mutlu anılar biriktirmenizi
                  temenni ediyoruz. Mutlu yıllar!
                </li>
                <li>
                  Yeni yılın kurumumuza başarı, mutluluk ve huzur getirmesini
                  diliyorum. Yeni yılınızı en i&ccedil;ten dileklerimle
                  kutlarım.
                </li>
                <li>
                  <p>
                    Yeni yılda hatalarımızın az, başarılarımızın devamlı olması
                    dileğiyle. Mutlu yıllar.
                  </p>
                </li>
              </ul>

              <p>
                <strong>Şirketler i&ccedil;in yeni yıl mesajları</strong> ile
                kurumsal hedeflerine ulaşırken birlikte emek sarf ettiğin
                arkadaşlarının y&uuml;z&uuml;n&uuml; g&uuml;ld&uuml;rebilirsin.
                Ayrıca t&uuml;m &ccedil;alışanlara toplu olarak SMS atmak da
                Mesaj &uuml;ss&uuml; paketleriyle olduk&ccedil;a pratik. Yeni
                yıl mesajı kurumsal yılbaşı tebriklerini t&uuml;m
                &ccedil;alışanlara g&ouml;ndermek i&ccedil;in Mesaj
                &uuml;ss&uuml; toplu SMS avantajlarından yararlanabilirsin.{' '}
              </p>

              <h2>
                <strong>Kısa Yeni Yıl S&ouml;zleri </strong>
              </h2>
              <p>
                Herkesin tercih ettiği yeni yıl mesajları, tarzına g&ouml;re
                değişiklik g&ouml;sterebilir. Kimileri yılbaşı dileklerini
                eğlenceli ve dikkat &ccedil;ekici mesajlarla iletirken kimileri
                ise sade ve etkileyici metinleri tercih eder. Kısa yeni yıl
                s&ouml;zleri ile iyi dileklerini en yalın hâliyle iletmek
                istersen şu mesajları değerlendirebilirsin:
              </p>
              <ul>
                <li>
                  Yeni yılda y&uuml;z&uuml;nden g&uuml;l&uuml;c&uuml;kler,
                  kalbinden sevgi eksik olmasın.
                </li>
                <li>
                  Mutluluk yağmurları altında şemsiyesiz kalacağın bir yıl
                  dilerim.
                </li>
                <li>
                  Bol kazan&ccedil;lı, keyifli ve sevgi dolu bir yıl
                  ge&ccedil;irmenizi temenni ederim.
                </li>
                <li>
                  Yılbaşı gecesinde dilediğiniz t&uuml;m dilekler ger&ccedil;ek
                  olsun. Mutlu yıllar!
                </li>
                <li>
                  D&uuml;ş kurmadan hayaller ger&ccedil;ek olmaz. Yeni yılda
                  t&uuml;m d&uuml;şlerinizin ger&ccedil;ek olması dileğiyle!
                </li>
                <li>Yeni yıl sağlık, barış, huzur ve bereketin yılı olsun.</li>
                <li>
                  İyisiyle k&ouml;t&uuml;s&uuml;yle bir yılı daha geride
                  bıraktık. Hoş geldin yeni yıl!
                </li>
                <li>
                  Yeni yılın hayatına mutluluk ve neşe getirmesini dilerim. En
                  i&ccedil;ten sevgilerimle.
                </li>
                <li>Yeni yıl değişim, başarı ve sağlık getirsin.</li>
                <li>
                  <p>
                    T&uuml;m dileklerinizin ger&ccedil;ekleşeceği bir yıl
                    temenni ediyorum.
                  </p>
                </li>
              </ul>

              <p>
                Sade yeni yıl mesajlarının en iyi &ouml;zelliklerinden birisi
                akılda kalıcı olmasıdır. Sevdiklerinin, ailenin ve iş
                arkadaşlarının yeni yılını bu mesajlarla kutlayabilirsin.
                Beğendiğin mesajı <strong>toplu SMS</strong> ile t&uuml;m
                sevdiklerine g&ouml;nderebilirsin.
              </p>
              <h2>
                <strong>En Etkileyici Yılbaşı Mesajları</strong>
              </h2>
              <p>
                Yeni yıl mesajları, yılbaşına renk katan olmazsa olmaz iletiler.
                Bu &ouml;zel g&uuml;nde sevdiklerine g&ouml;nderebileceğin en
                etkileyici yılbaşı mesajlarını senin i&ccedil;in derledik:
              </p>
              <ul>
                <li>
                  Sevdiklerinde huzurlu ve mutlu bir yaşamın olsun. Hayat sana
                  her zaman g&uuml;zel s&uuml;rprizlerle gelsin. Mutlu yıllar!
                </li>

                <li>
                  Yeni yılda en g&uuml;zel dileklerin ger&ccedil;ek olsun. Şans,
                  huzur ve sağlık dolu bir yıl dilerim.
                </li>

                <li>
                  Yeni yılda attığın her adımda başarı yanında olsun.
                  &ouml;mr&uuml;n&uuml;n huzur dolacağı, sevginin daim olacağı
                  bir sene ge&ccedil;irmen dileğiyle.
                </li>

                <li>
                  D&uuml;nyanın g&uuml;neş etrafındaki turunu tamamlamasını
                  kutladığımız şu g&uuml;nde, senin hayatımda olman bana en
                  g&uuml;zel hediye. Nice yıllara!
                </li>

                <li>
                  Yaşamın olduğu her yerde umut da vardır. Yeni yılda t&uuml;m
                  hayallerin ger&ccedil;ek olsun. Mutlu yıllar.{' '}
                </li>

                <li>
                  Dostluğumuza bir yıl daha eklemenin mutluluğunu tarif edemem.
                  Birlikte nice keyif ve huzur dolu yıllara, iyi ki varsın!
                </li>

                <li>
                  Yeni yıla nasıl girersen &ouml;yle s&uuml;rermiş diyorlar. Ben
                  de yeni yıla seni g&uuml;l&uuml;mseterek girmek istedim.
                  Y&uuml;z&uuml;nden g&uuml;l&uuml;c&uuml;kler hi&ccedil; eksik
                  olmasın.
                </li>

                <li>
                  Etrafının daima sevdiklerinle &ccedil;evrili olduğu huzurlu ve
                  mutlu bir yıl diliyorum.{' '}
                </li>
                <li>
                  Ge&ccedil;en yıl benim i&ccedil;in olduk&ccedil;a &ouml;zel
                  bir sene oldu &ccedil;&uuml;nk&uuml; seni tanıdım.
                  &ouml;n&uuml;m&uuml;zdeki yıl daha da &ouml;zel olacak
                  &ccedil;&uuml;nk&uuml; sen yanımdasın. Nice senelere!
                </li>
                <li>
                  <p>
                    {' '}
                    Kapının aşk, başarı ve mutluluk ile &ccedil;alınacağı harika
                    bir yıl ge&ccedil;irmen dileğiyle.
                  </p>
                </li>
              </ul>
              <p>
                Yakın dostlarını, aile &uuml;yelerini ve tanıdıklarını
                etkileyici yeni yıl mesajları ile mutlu etmeye ne dersin?
                Yepyeni bir yılı &ouml;zellikle sevdiklerinden uzakta
                karşılayacak pek &ccedil;ok kişi i&ccedil;in iyi dilekleri
                paylaşmanın en kolay yolunun mesajlaşmak olduğu kesin. Mesaj
                &uuml;ss&uuml; ile sana en uygun{' '}
                <a href="https://mesajussu.turkcell.com.tr/toplu-sms">
                  <strong>
                    <u>toplu SMS</u>
                  </strong>
                </a>{' '}
                kampanyasını belirleyebilir, yılbaşı coşkusunu sevdiklerinle
                paylaşabilirsin.{' '}
              </p>

              <h2>
                <strong>Enteresan Yeni Yıl Mesajları </strong>
              </h2>
              <p>
                Yılbaşı kutlama mesajları ile uzakları yakın etmek, neşe ve umut
                i&ccedil;eren dilekler paylaşmak m&uuml;mk&uuml;n. Tabii yakın
                dostlara ve aileye enteresan ve esprili mesajlar
                g&ouml;ndermenin keyfi de bir başka. Birbirinden keyifli yeni
                yıl mesajlarından bazılarını senin i&ccedil;in derledik:
              </p>
              <ul>
                <li>
                  İşte sonunda buldum. Neyi mi? Dostluğumuzun yeni yılda da
                  devam edebileceğini anlatacak sıcak bir mesaj atma fırsatını.
                  Mutlu yıllar!
                </li>
                <li>Ho ho ho! Yepyeni bir yıla sevdiklerinle merhaba de!</li>
                <li>
                  Hadi yine iyisin dostum! Bir yılı daha kazasız belasız
                  atlattın, iyi seneler.
                </li>
                <li>
                  Yeni yıl mutluluk, sağlık, huzur getirsin. Getirmezse de
                  takma. &ouml;n&uuml;m&uuml;zde daha &ccedil;ok yıl var.
                </li>
                <li>
                  Yeni yılın c&uuml;zdanına para, kalbine aşk ve hayatına
                  d&uuml;zen getirmesini temenni ederim.
                </li>
                <li>
                  Yeni yıl sana istediğinden daha fazla para getirsin ki bana
                  pahalı hediyeler alabilesin.
                </li>
                <li>
                  <p>
                    {' '}
                    Umarım mutluluk ve huzur denizlerinde boğulursun. İyi
                    seneler!
                  </p>
                </li>
              </ul>
              <p>
                Mesaj &uuml;ss&uuml;’ne &uuml;ye olarak senin i&ccedil;in en
                uygun olan mesaj paketini satın alabilir, sevdiklerine dilediğin
                t&uuml;rden yeni yıl tebrikleri g&ouml;nderebilirsin. T&uuml;m
                evrenin umut ve neşeyle dolduğu bu &ouml;zel g&uuml;nde
                mutluluğunu <strong>yeni yıl mesajları</strong> ile
                d&uuml;nyanın d&ouml;rt bir yanındaki sevdiklerine
                aktarabilirsin.
              </p>
            </ul>
          </div>
        </div>
      </div>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default YeniYil;
